import { render, staticRenderFns } from "./RestaurantTableOrderBadge.vue?vue&type=template&id=7f05b8a0"
import script from "./RestaurantTableOrderBadge.vue?vue&type=script&lang=js"
export * from "./RestaurantTableOrderBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports